module.exports = __webpack_public_path__ + "img/icon_yunyingguan.3106aa21.png";